import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Functional component to scroll window to top each time the browser location
 * pathname changes
 *
 * We should extract this to `src/components/common` when we need to use it somewhere else
 */
export function useScrollToTop(wrapperElement?: HTMLElement | null) {
  const { pathname } = useLocation()

  React.useEffect(() => {
    const innerScrollElement = document.getElementById('page-header-content')
    if (window.pageYOffset) {
      window.scrollTo(0, 0)
    } else if (innerScrollElement?.scrollTop) {
      innerScrollElement.scrollTo(0, 0)
    }
  }, [pathname, wrapperElement])

  return null
}
